(() => {
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.UGCartMotion = {
    capture(form) {
      if (reduced()) return null;
      const scope = form.closest('product-info, quick-add-modal, .card-wrapper') || document;
      const img = scope.querySelector('.product__media-item.is-active img, .product__media img, .card__media img');
      if (!img) return null;
      const rect = img.getBoundingClientRect();
      const button = form.querySelector('[type="submit"]')?.getBoundingClientRect();
      return { src: img.currentSrc || img.src, rect: rect.bottom > 0 && rect.top < innerHeight ? rect : button };
    },
    async fly(snapshot) {
      if (!snapshot?.rect || reduced()) return;
      const target = document.querySelector('#cart-icon-bubble');
      if (!target) return;
      const end = target.getBoundingClientRect();
      if (end.bottom <= 0 || end.top >= innerHeight) return;
      const start = snapshot.rect;
      const size = Math.min(160, Math.max(80, start.width));
      const x = Math.max(0, Math.min(innerWidth - size, start.left + start.width / 2 - size / 2));
      const y = Math.max(0, Math.min(innerHeight - size, start.top + start.height / 2 - size / 2));
      const ghost = document.createElement('img');
      ghost.src = snapshot.src;
      ghost.alt = '';
      ghost.setAttribute('aria-hidden', 'true');
      ghost.className = 'ug-cart-flight';
      Object.assign(ghost.style, { left: `${x}px`, top: `${y}px`, width: `${size}px`, height: `${size}px` });
      document.body.append(ghost);
      try {
        const dx = end.left + end.width / 2 - x - size / 2;
        const dy = end.top + end.height / 2 - y - size / 2;
        await ghost.animate([
          { transform: 'translate(0,0) scale(1) rotate(-5deg)', opacity: 1 },
          { transform: `translate(${dx * .48}px,${dy * .62 - 35}px) scale(.65) rotate(7deg)`, opacity: .95, offset: .5 },
          { transform: `translate(${dx}px,${dy}px) scale(.12) rotate(0deg)`, opacity: 0 }
        ], { duration: innerWidth < 750 ? 440 : 620, easing: 'cubic-bezier(.22,.61,.36,1)' }).finished;
        target.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.15)' }, { transform: 'scale(1)' }], { duration: 260 });
      } finally { ghost.remove(); }
    }
  };
})();

(() => {
 let busy = false;
 document.addEventListener('click', async event => {
  const button = event.target.closest('[data-ug-add-accessory],[data-ug-add-gift]');
  if (!button || button.disabled || busy || window.UGCartRuntime?.busy) return;
  const panel = button.closest('ug-cart-accessories,[data-ug-gift]');
  if (!panel) return;
  event.preventDefault();
  const status = panel.querySelector('[role="status"]');
  const original = button.textContent;
  const fromDrawer = !!button.closest('cart-drawer');
  const variantId = Number(button.dataset.ugAddAccessory || button.dataset.ugAddGift);
  if (!Number.isSafeInteger(variantId) || variantId <= 0) return;
  busy = true;
  window.UGCartRuntime?.begin();
  button.disabled = true;
  button.textContent = panel.dataset.loading || 'Dodajem…';
  if (status) status.textContent = '';
  let added = false;
  const pageSections = ['main-cart-items', 'main-cart-footer'].map(id => ({id, section:document.getElementById(id)?.dataset.id})).filter(item => item.section);
  const sections = [...new Set(['cart-drawer', 'cart-icon-bubble', ...pageSections.map(item => item.section)])];
  try {
   const addUrl = window.routes.cart_add_url.endsWith('.js') ? window.routes.cart_add_url : window.routes.cart_add_url + '.js';
   const response = await fetch(addUrl, {
    method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({items:[{id:variantId,quantity:1}],sections,sections_url:location.pathname})
   });
   const data = await response.json();
   if (!response.ok || data.status) throw new Error(data.description || (panel.dataset.error || 'Proizvod nije dodat. Pokušaj ponovo.'));
   added = true;
   if (!data.sections || sections.some(id => !data.sections[id])) { location.reload(); return; }
   const parser = new DOMParser();
   const drawer = document.querySelector('cart-drawer');
   if (fromDrawer && drawer) {
    drawer.setActiveElement(document.querySelector('#cart-icon-bubble'));
    drawer.renderContents(data);
    requestAnimationFrame(() => {
     const target = drawer.querySelector('[data-ug-add-accessory="' + variantId + '"]');
     target?.focus({preventScroll:true});
     const message = drawer.querySelector('ug-cart-accessories [role="status"]');
     if (message) message.textContent = (panel.dataset.added || 'Poklon torbica je dodata u korpu.');
    });
   } else {
    const icon = document.querySelector('#cart-icon-bubble');
    const newIcon = parser.parseFromString(data.sections['cart-icon-bubble'],'text/html').querySelector('.shopify-section');
    if (icon && newIcon) icon.innerHTML = newIcon.innerHTML;
    if (drawer) {
     const inner = parser.parseFromString(data.sections['cart-drawer'],'text/html').querySelector('#CartDrawer');
     if (inner) drawer.querySelector('#CartDrawer').innerHTML = inner.innerHTML;
     drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
    }
   }
   for (const item of pageSections) {
    const fresh = parser.parseFromString(data.sections[item.section],'text/html').getElementById(item.id);
    const current = document.getElementById(item.id);
    if (item.id === 'main-cart-footer' && window.UGCartRuntime) window.UGCartRuntime.renderFooter(data.sections[item.section]);
    else if (fresh && current) current.replaceWith(fresh);
   }
   if (!fromDrawer) {
    const target = document.querySelector('[data-ug-add-accessory="' + variantId + '"]');
    target?.focus({preventScroll:true});
    const message = document.querySelector('#main-cart-footer ug-cart-accessories [role="status"]');
    if (message) message.textContent = (panel.dataset.added || 'Poklon torbica je dodata u korpu.');
   }
   if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'cart-items',cartData:data});
  } catch (error) {
   if (added) { location.reload(); return; }
   if (status) status.textContent = error.message || panel.dataset.error;
  } finally {
   busy = false;
   window.UGCartRuntime?.end();
   if (button.isConnected) {button.disabled = false;button.textContent = original;}
  }
 });
})();

